"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var router_1 = require("@angular/router");
var operators_1 = require("rxjs/operators");
var WickedApiClient_1 = require("../api/WickedApiClient");
var i0 = require("@angular/core");
var i1 = require("@angular/router");
var i2 = require("../api/WickedApiClient");
//search-results/:casualDating/:relationShip/:withPicture/:state/:city
exports.Categories = {
    "women-seeking-men": 1,
    "women-seeking-women": 2,
    "women-seeking-couples": 3,
    "women-seeking-transgenders": 4,
    "men-seeking-women": 5,
    "men-seeking-men": 6,
    "men-seeking-couples": 7,
    "men-seeking-transgenders": 8,
    "couples-seeking-women": 9,
    "couples-seeking-men": 10,
    "couples-seeking-couples": 11,
    "couples-seeking-transgenders": 12,
    "transgenders-seeking-women": 13,
    "transgenders-seeking-men": 14,
    "transgenders-seeking-couples": 15,
    "transgenders-seeking-transgenders": 16,
    "missed-connections": 17
};
exports.RegexSearchList = "^(?<state>[a-z]{2})(?:-)(?<city>[\\w\\W]+)(?:-)\\b(?:(?<type>casual-dating|long-term))((?:-)\\b(?:(?<category>" + Object.keys(exports.Categories).join("|") + ")))?(?:(?<withPicture>-with-picture))?((?:-)(?<page>page-[0-9]+))?((?:-)(?<per>per-(4|12|24|100)))?";
exports.RegexCategory = "^(?<type>casual-dating|long-term)-(?<category>" + Object.keys(exports.Categories).join("|") + ")$";
exports.RegexCity = "^(?<state>[a-z]{2})(?:-)(?<city>[\\w\\W]+)$";
exports.RegexSearchResults = "^search-results((?:-)(?<page>page-[0-9]+))?((?:-)(?<per>per-(4|12|24|100)))?";
exports.States = {
    "WA": 3,
    "IL": 4,
    "GA": 5,
    "IN": 6,
    "IA": 7,
    "MA": 8,
    "AZ": 9,
    "ID": 10,
    "CT": 11,
    "ME": 12,
    "MD": 13,
    "VT": 14,
    "OK": 15,
    "UT": 16,
    "MO": 17,
    "MN": 18,
    "MI": 19,
    "KS": 20,
    "MT": 21,
    "MS": 22,
    "PR": 23,
    "SC": 24,
    "KY": 25,
    "OH": 26,
    "AR": 27,
    "AL": 28,
    "CA": 29,
    "DE": 30,
    "DC": 31,
    "WI": 32,
    "WV": 33,
    "HI": 34,
    "FL": 35,
    "WY": 36,
    "NH": 37,
    "NJ": 38,
    "NM": 39,
    "TX": 40,
    "LA": 41,
    "AK": 42,
    "NC": 43,
    "ND": 44,
    "NE": 45,
    "TN": 46,
    "NY": 47,
    "PA": 48,
    "RI": 49,
    "NV": 50,
    "VA": 51,
    "CO": 52,
    "OR": 53,
    "SD": 54
};
var SearchRouteService = /** @class */ (function () {
    function SearchRouteService(router, advertisementsClient) {
        var _this = this;
        this.router = router;
        this.advertisementsClient = advertisementsClient;
        this.categories = {
            "women-seeking-men": 1,
            "women-seeking-women": 2,
            "women-seeking-couples": 3,
            "women-seeking-transgenders": 4,
            "men-seeking-women": 5,
            "men-seeking-men": 6,
            "men-seeking-couples": 7,
            "men-seeking-transgenders": 8,
            "couples-seeking-women": 9,
            "couples-seeking-men": 10,
            "couples-seeking-couples": 11,
            "couples-seeking-transgenders": 12,
            "transgenders-seeking-women": 13,
            "transgenders-seeking-men": 14,
            "transgenders-seeking-couples": 15,
            "transgenders-seeking-transgenders": 16,
            "missed-connections": 17
        };
        this.states = {
            "WA": 3,
            "IL": 4,
            "GA": 5,
            "IN": 6,
            "IA": 7,
            "MA": 8,
            "AZ": 9,
            "ID": 10,
            "CT": 11,
            "ME": 12,
            "MD": 13,
            "VT": 14,
            "OK": 15,
            "UT": 16,
            "MO": 17,
            "MN": 18,
            "MI": 19,
            "KS": 20,
            "MT": 21,
            "MS": 22,
            "PR": 23,
            "SC": 24,
            "KY": 25,
            "OH": 26,
            "AR": 27,
            "AL": 28,
            "CA": 29,
            "DE": 30,
            "DC": 31,
            "WI": 32,
            "WV": 33,
            "HI": 34,
            "FL": 35,
            "WY": 36,
            "NH": 37,
            "NJ": 38,
            "NM": 39,
            "TX": 40,
            "LA": 41,
            "AK": 42,
            "NC": 43,
            "ND": 44,
            "NE": 45,
            "TN": 46,
            "NY": 47,
            "PA": 48,
            "RI": 49,
            "NV": 50,
            "VA": 51,
            "CO": 52,
            "OR": 53,
            "SD": 54
        };
        this.router = router;
        this.paramsSnapshot = {};
        this.params = new rxjs_1.BehaviorSubject(this.paramsSnapshot);
        this.paramsData = new rxjs_1.Subject();
        this.categoryData = new rxjs_1.Subject();
        this.router.events
            .pipe(operators_1.filter(function (event) {
            return (event instanceof router_1.NavigationEnd);
        }))
            .subscribe(function (event) {
            if (_this.router.url.indexOf("/search-results/") == 0) {
                var snapshot = _this.router.routerState.snapshot.root;
                var nextParams = _this.collectParams(snapshot);
                if (_this.paramsAreDifferent(_this.paramsSnapshot, nextParams)) {
                    _this.getParamsData(nextParams).subscribe(function (data) {
                        _this.paramsData.next(data);
                    });
                    _this.params.next(_this.paramsSnapshot = nextParams);
                }
            }
            else {
                var categoriesKeys = Object.keys(_this.categories);
                for (var i = 0; i < categoriesKeys.length; i++) {
                    if (_this.router.url.indexOf("/casual-dating/" + categoriesKeys[i]) == 0) {
                        _this.categoryData.next({ casualDating: true, categoryKey: categoriesKeys[i], categoryId: _this.categories[categoriesKeys[i]] });
                        break;
                    }
                    else if (_this.router.url.indexOf("/long-term/" + categoriesKeys[i]) == 0) {
                        _this.categoryData.next({ casualDating: false, categoryKey: categoriesKeys[i], categoryId: _this.categories[categoriesKeys[i]] });
                        break;
                    }
                }
            }
        });
    }
    SearchRouteService.prototype.isRouteSearch = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.router.events
                .subscribe(function (event) {
                console.log(event);
                var regexSearch = "^(?<state>[a-z]{2})(?:-)(?<city>[\\w\\W]+)(?:-)\\b(?:(?<type>casual-dating|long-term))((?:-)\\b(?:(?<category>" + Object.keys(exports.Categories).join("|") + ")))?(?:(?<withPicture>-with-picture))?";
                var regex = new RegExp(regexSearch, "gi");
                var regexMatch = regex.exec(event.url.replace("/", ""));
                if (regexMatch != null && regexMatch.groups != null) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            });
        });
    };
    SearchRouteService.prototype.getCategoryUrl = function (categoryId) {
        var url = "";
        for (var i in this.categories) {
            if (this.categories[i] == categoryId) {
                url = "" + i;
            }
        }
        return url;
    };
    SearchRouteService.prototype.getParamsData = function (params) {
        var _this = this;
        return new rxjs_1.Observable(function (observable) {
            if (!_this.validateRequest(params)) {
                observable.next({ isValid: false });
            }
            var isSearchByZip = !isNaN(params["state"]);
            var casualDating = params["casualDating"];
            var relationship = params["relationShip"];
            var withPicture = params["withPicture"];
            var state = params["state"];
            var city = params["city"];
            var data = {
                isValid: true,
                params: params,
                isSearchByZip: isSearchByZip,
                paramsSearchData: {
                    casualDating: casualDating.toLowerCase() == 'casual-dating',
                    categoryId: _this.categories[relationship.toLowerCase()],
                    withPicture: withPicture == "with-picture",
                }
            };
            if (isSearchByZip) {
                data.paramsSearchData.radius = Number(state);
                data.paramsSearchData.zipCode = city;
                observable.next(data);
            }
            else {
                data.paramsSearchData.state = _this.states[state];
                _this.advertisementsClient.getChildrenSubRegions(data.paramsSearchData.state).toPromise().then(function (cities) {
                    var c = cities.filter(function (c) { return c.zip == city; });
                    if (c.length) {
                        data.paramsSearchData.city = c[0].subRegionId;
                        observable.next(data);
                    }
                });
            }
        });
    };
    SearchRouteService.prototype.validateRequest = function (params) {
        var casualDating = params["casualDating"];
        var relationship = params["relationShip"];
        var withPicture = params["withPicture"];
        var state = params["state"];
        var city = params["city"];
        if (casualDating == null || relationship == null || withPicture == null || state == null || city == null) {
            return false;
        }
        if (["casual-dating", "long-term"].indexOf(casualDating.toLowerCase()) == -1) {
            return false;
        }
        if (this.categories[relationship.toLowerCase()] == null) {
            return false;
        }
        if (["all", "with-picture"].indexOf(withPicture.toLowerCase()) == -1) {
            return false;
        }
        return true;
    };
    SearchRouteService.prototype.collectParams = function (root) {
        var params = {};
        (function mergeParamsFromSnapshot(snapshot) {
            params = __assign({}, snapshot.params);
            snapshot.children.forEach(mergeParamsFromSnapshot);
        })(root);
        return (params);
    };
    SearchRouteService.prototype.paramsAreDifferent = function (currentParams, nextParams) {
        var currentKeys = Object.keys(currentParams);
        var nextKeys = Object.keys(nextParams);
        if (currentKeys.length !== nextKeys.length) {
            return (true);
        }
        for (var i = 0, length = currentKeys.length; i < length; i++) {
            var key = currentKeys[i];
            if (currentParams[key] !== nextParams[key]) {
                return (true);
            }
        }
        return (false);
    };
    SearchRouteService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SearchRouteService_Factory() { return new SearchRouteService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AdveristmentsClient)); }, token: SearchRouteService, providedIn: "root" });
    return SearchRouteService;
}());
exports.SearchRouteService = SearchRouteService;
